/* globals _paq */
import { formatDefaultLocale } from 'd3-format';
import germanFormat from 'd3-format/locale/de-DE';
import debounce from 'lodash.debounce';

const germanNumberFormat = formatDefaultLocale(germanFormat);

export function nf(num, decimals = 0, unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(`,.${decimals}f`)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export function trackEvent(name, data) {
  if (typeof _paq !== 'undefined') {
    _paq.push(['trackEvent', name, data, config.headline]);
  }
}

function resizeIframe() {
  window.parent.postMessage(
    {
      idwWohnflaecheFrameHeight: document.body.clientHeight,
    },
    '*'
  );
}

export const resizeIframeDebounced = debounce(resizeIframe, 100);

export default {
  nf,
  trackEvent,
  resizeIframeDebounced,
};
